import moment from 'moment';

moment.locale('pt-br');

const formatFullDate = (dateString) => {
    let teste = moment(dateString).format('DD/MM/yyyy HH:mm');
    teste.t
    return moment(dateString).format('DD/MM/yyyy HH:mm');
}

const formatShortDate = (dateString) => {
    return moment(dateString).format('DD/MM/yyyy');
}            

const formatSchedulingDate = (date) => {
    let mDate = moment(date);            
    let day = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"][mDate.day()];

    return `${mDate.format('DD/MM/yyyy')} (${day})`;
}

const formatDateWithoutYear = (date) => {
    let mDate = moment(date);                        

    return `${mDate.format('DD/MM')}`;
}

const formatSchedulingTime = (startDate, endDate) => {
    let mStartDate = moment(startDate);
    let mEndDate = moment(endDate);

    return `Das ${mStartDate.format("HH:mm")} Às ${mEndDate.format("HH:mm")}`;
}

const formatDateTimeToExtense = (dateTime) => {  
    let date = moment(dateTime);
    
    if (date.isValid())
        return date.format('LLLL')
    else
        return "";
}

const formatSchedulingDateTime = (startDate, endDate) => {
    return `${this.formatSchedulingDate(startDate)} ${this.formatSchedulingTime(startDate, endDate)}`;
}

const convertPeriod = (period) => {

    let result = "";

    if (period == 1) {
        result = "Manhã";
    }
    else if (period == 2) {
        result = "Tarde";
    }
    else if (period == 3) {
        result = "Noite";
    }
    else {
        result = "Não Informado";
    }

    return result;
}

const convertHumor = (humor) => {
    let result = "";

    if (humor == 1) {
        result = "Péssimo";
    }
    else if (humor == 2) {
        result = "Ruim";
    }
    else if (humor == 3) {
        result = "Bem";
    }
    else if (humor == 4) {
        result = "Muito Bem";
    }
    else if (humor == 5) {
        result = "Excelente";
    }
    else {
        result = "Não Informado";
    }

    return result
}

const convertObjectToArray = (obj) => {
    const values = Object.values(obj);
    const keys = Object.keys(obj);
    const result = [];            

    for(let index = 0; index < values.length; index++) {
        result.push({key:keys[index], value:values[index]});
    }

    return result;
}

export {
    formatFullDate,
    formatShortDate,
    formatSchedulingDate,
    formatDateWithoutYear,
    formatSchedulingTime,
    formatDateTimeToExtense,
    formatSchedulingDateTime,
    convertPeriod,
    convertHumor,
    convertObjectToArray
} 
